import { request } from "../request";
export type InputGetAllNoticeListQueryFilter = {
  Title?: string,
  StartTime?: number;
  EndTime?: number;
  Email?: string;
  Phone?: string;
};

export type OutputGetAllNoticeList = {
  User?: {
    Phone: string,
    NickName: string,
    Email: string
  },
  Href?: string,
  Title?: string,
  Status?: boolean,
  IsPublic?: boolean,
  Thumbnail?: string,
  EndTime?: number,
  StartTime?: number,
  TargetUid?: string,
  CreateAt?: number
};

/**
 * 获取通知数据列表
 * @returns
 */
export function fetchGetAllNoticeListAsync(page: number, pageSize: number, queryFilter: InputGetAllNoticeListQueryFilter) {
  return request<{
    total: number,
    list: OutputGetAllNoticeList[]
  }>({
    url: '/Notice/GetAllNoticeList',
    method: 'post',
    data: queryFilter,
    params: {
      page,
      pageSize
    }
  })
}

export type InputAddNotice = {
  Title?: string,
  Href?: string;
  PhoneOrEmail?: string;
  StartTime?: number;
  EndTime?: number;
  Thumbnail?: string;
  Content?: string;
  Status?: boolean
};

/**
 * 添加通知/公告
 * @returns
 */
export function fetchAddNoticeAsync(input: InputAddNotice) {
  return request({
    url: '/Notice/AddNotice',
    method: 'post',
    data: input
  })
}

export type InputUpdateNotice = {
  Id?: number
} & InputAddNotice;

/**
 * 修改 通知/公告
 * @param input
 * @returns
 */
export function fetchUpdateNoticeAsync(input: InputUpdateNotice) {
  return request({
    url: '/Notice/UpdateNotice',
    method: 'post',
    data: input
  })
}

/**
 * 删除 通知/公告
 * @param Id
 * @returns
 */
export function fetchDeleteNoticeAsync(Id: number) {
  return request({
    url: '/Notice/DeleteNotice',
    method: 'delete',
    params: { Id }
  })
}

/**
 * 获取我的通知列表
 */
export function fetchGetMyNoticeListAsync() {
  return request<DB.Notice[]>({
    url: '/Notice/GetMyNoticeList',
    method: 'get'
  })
}
